import {
  badge_styles_default
} from "./chunk.7UMJRADG.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/badge/badge.ts
import { t } from "i18next";
var FadvBadge = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlot = new HasSlotController(this, "[default]", "prefix", "suffix");
    this.duotone = false;
    this.size = "small";
    this.pill = false;
    this.pulse = false;
    this.dot = false;
    this.removable = false;
  }
  handleRemoveClick() {
    emit(this, "sl-remove");
  }
  handleSlotChange(event) {
    const slot = event.target;
    const elements = slot.assignedElements() || [];
    elements.filter((e2) => hasTag(e2, "fadv-badge")).forEach((e2) => {
      e2.classList.add("sub-badge");
      e2.classList.add(`sub-badge--${e2.variant || "default"}`);
    });
  }
  renderRemovable() {
    if (!this.removable)
      return w;
    return $`<button aria-label=${t("components:common.remove")} class="badge__remove-button" @click=${this.handleRemoveClick}><svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M6.89545 5L9.73835 2.1571C10.0872 1.80824 10.0872 1.24261 9.73835 0.893466L9.10653 0.261648C8.75767 -0.0872159 8.19205 -0.0872159 7.8429 0.261648L5 3.10455L2.1571 0.261648C1.80824 -0.0872159 1.24261 -0.0872159 0.893466 0.261648L0.261648 0.893466C-0.0872159 1.24233 -0.0872159 1.80795 0.261648 2.1571L3.10455 5L0.261648 7.8429C-0.0872159 8.19176 -0.0872159 8.75739 0.261648 9.10653L0.893466 9.73835C1.24233 10.0872 1.80824 10.0872 2.1571 9.73835L5 6.89545L7.8429 9.73835C8.19176 10.0872 8.75767 10.0872 9.10653 9.73835L9.73835 9.10653C10.0872 8.75767 10.0872 8.19205 9.73835 7.8429L6.89545 5Z" /></svg></button>`;
  }
  render() {
    return $`<span part="base" class=${o({
      badge: true,
      "badge--primary": this.variant === "primary",
      "badge--secondary": this.variant === "secondary",
      "badge--tertiary": this.variant === "tertiary",
      "badge--success": this.variant === "success",
      "badge--neutral": this.variant === "neutral",
      "badge--warning": this.variant === "warning",
      "badge--danger": this.variant === "danger",
      "badge--gray": this.variant === "gray",
      "badge--pulse": this.pulse,
      "badge--pill": this.pill,
      "badge--dot": this.dot,
      "badge--small": this.size === "small",
      "badge--large": this.size === "large",
      "badge--removable": this.removable,
      "badge--has-prefix": this.hasSlot.test("prefix"),
      "badge--has-suffix": this.hasSlot.test("suffix"),
      "badge--duotone": this.duotone
    })} role="status" ><span class="badge__prefix"><slot name="prefix" @slotchange=${this.handleSlotChange}></slot></span><span class="badge__label"><slot></slot></span><span class="badge__suffix"><slot name="suffix" @slotchange=${this.handleSlotChange}></slot></span>${this.renderRemovable()}</span>`;
  }
};
FadvBadge.styles = badge_styles_default;
__decorateClass([
  i(".badge")
], FadvBadge.prototype, "badge", 2);
__decorateClass([
  e({ reflect: true })
], FadvBadge.prototype, "variant", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvBadge.prototype, "duotone", 2);
__decorateClass([
  e()
], FadvBadge.prototype, "size", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvBadge.prototype, "pill", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvBadge.prototype, "pulse", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvBadge.prototype, "dot", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvBadge.prototype, "removable", 2);
FadvBadge = __decorateClass([
  n("fadv-badge")
], FadvBadge);

export {
  FadvBadge
};
